var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"gst-booking-layout-group gst-booking-layout-group--background"},[_vm._t("status"),_vm._t("order-number"),_vm._t("default")],2),_vm._t("payment-summary"),_vm._t("cancellation-policy")],2)}
var staticRenderFns = []

export { render, staticRenderFns }